import { axiosInstance } from "./index";
import { ApiResponse, ApiRequest } from "./types";

export const getContentOffers = async () => {
  const response = await axiosInstance.get<ApiResponse.ContentOffersByYear>(
    `/api/recruitment_review/v1/content_offers`
  );
  return response;
};

export const getContentOffer = async (params: ApiRequest.GetContentOffer) => {
  const response = await axiosInstance.get<ApiResponse.ContentOffer>(
    `/api/recruitment_review/v1/content_offers/${params.offerId}`
  );
  return response;
};

export const updateContentOffer = async (
  params: ApiRequest.UpdateContentOffer
) => {
  const response = await axiosInstance.put(
    `/api/recruitment_review/v1/content_offers/${params.offerId}`,
    {
      mail_body: params.mail_body
    }
  );
  return response;
};

export const restoreContentOffer = async (
  params: ApiRequest.GetContentOffer
) => {
  const response = await axiosInstance.put<ApiResponse.ContentOfferMailBody>(
    `/api/recruitment_review/v1/content_offers/${params.offerId}/restore`
  );
  return response;
};
